module.exports = __webpack_public_path__ + "static/img/card_feature_active_bg.e5751d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rescuelist/card_feature_active_bg.png
// module id = 05jQ
// module chunks = 1